import "./post-contents.css";

window.addEventListener("DOMContentLoaded", () => {
	
	const tocLinks = document.querySelectorAll(".des-toc-link");
	tocLinks.forEach((tocLink) => {

		tocLink.addEventListener("click", (event) => {
			let id = event.target.getAttribute("href").replace(/#/g, "");
			let bookmark = document.getElementById(id);
			bookmark.scrollIntoView({
				behavior: "smooth",
			});
			event.preventDefault();
			window.location.href =
			 	"#bookmark-" + id;
		});
	});

	if (window.location.hash != "") {
		let id = window.location.hash.replace(/^#bookmark-/, "");
		let bookmark = document.getElementById(id);

		if (bookmark)
		{
			window.location = "#" + id;
		}
	}
});
